import { breakpoint } from '../../../scripts/helpers/breakpoints';
window.anvil.component('header', (el, data) => {
    // DOM elements
    const menuToggler = el.querySelector('.js-mobile-menu-toggler');
    const menu = el.querySelector('.js-mobile-menu');
    const menuItems = el.querySelectorAll('.js-menu-item');
    const backButtons = el.querySelectorAll('.js-back');
    const sliderFeatured = el.querySelector('.js-slider-featured');
    const menuLinks = el.querySelectorAll('.menu-item a');
    const form = el.querySelector('.form');
    const subsiteSearchToggler = el.querySelector('#sub-site-search-toggler');

    // Scroll lock utility
    const scrollLock = {
        isLocked: () => {
            return document.body.classList.contains('scroll-lock');
        },

        lock: () => {
            document.body.classList.add('scroll-lock');
        },

        unlock: () => {
            document.body.classList.remove('scroll-lock');
        }
    };

    // Add/remove sticky class depending on the scrollY position.
    function toggleSticky() {
        el.classList.toggle('sticky', window.scrollY > 100);
    }

    // Watch for escape key event to close the Mega menu
    function mainMenuEscape(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            if (isOpen(menuToggler)) {
                toggleMenu();
            }
        }
    }

    // Toggle mobile menu
    function toggleMenu() {
        // const form = el.querySelector('.form');
        const activeItems = el.querySelectorAll('.js-submenu.active');

        el.classList.toggle('mobile-menu-active');
        [menuToggler, menu, form].forEach(item => {
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                item.setAttribute('aria-expanded', 'false');
                scrollLock.unlock();
            } else {
                item.classList.add('active');
                item.setAttribute('aria-expanded', 'true');
                scrollLock.lock();
            }
        });

        if (isOpen(menuToggler)) {
            setTimeout(() => {
                /* mobile display menuLinks at a new popup */
                if (breakpoint.is('<=tablet')) {
                    menuItems[0].focus();
                } else {
                    menuLinks[0].focus();
                }

                /* Watch escape event */
                document.addEventListener('keydown', mainMenuEscape);
            }, 100);
        } else {
            /*  closes the menu and return the focus to the main button */
            menuToggler.focus();

            /* unwatch escape event */
            document.removeEventListener('keydown', mainMenuEscape);
        }

        if (activeItems) {
            activeItems.forEach(submenu => {
                submenu.classList.remove('active');
                submenu.setAttribute('aria-expanded', 'false');
            });
        }
    }

    // Open submenu (mobile only)
    function openSubmenu({ currentTarget }) {
        const submenu = currentTarget.nextElementSibling;
        if (breakpoint.is('<=tablet') && submenu) {
            submenu.classList.add('active');
            [currentTarget, submenu].forEach(item => item.setAttribute('aria-expanded', 'true'));
        }
    }

    // Close submenu (mobile only)
    function closeSubmenu({ currentTarget }) {
        const submenu = currentTarget.parentElement.parentElement;
        if (breakpoint.is('<=tablet') && submenu) {
            submenu.classList.remove('active');
            [currentTarget, submenu].forEach(item => item.setAttribute('aria-expanded', 'false'));
        }
    }

    // Initialize featured Products Slider
    function initFeaturedSlider() {
        if (sliderFeatured) {
            new Swiper(sliderFeatured, {
                speed: 500,
                navigation: {
                    prevEl: el.querySelector('.js-prev'),
                    nextEl: el.querySelector('.js-next'),
                }
            });
        }
    }

    // Check if item has submenu items
    /*
    function hasPopup(menuitem) {
        return menuitem.getAttribute('aria-haspopup') === 'true';
    }
    */

    // Check if submenu item is open
    function isOpen(menuitem) {
        return menuitem.getAttribute('aria-expanded') === 'true';
    }

    /*
    Event listeners
    */
    // Open Mobile Menu.
    if (menuToggler) {
        menuToggler.addEventListener('click', toggleMenu);
    }

    // Add event listener to close the menu when it's not focused anymore
    el.addEventListener('focusout', event => {
        if (breakpoint.is('>=tablet')) {
            setTimeout(() => {
                if (el.contains(event.relatedTarget)) return;

                if (isOpen(menuToggler)) {
                    toggleMenu();
                }
            }, 100);
        }
    });

    // Add navigation using arrow keys
    if (menu) {
        menu.addEventListener('keydown', e => {
            if ( e.key === 'ArrowLeft' || e.keyCode === 37 || e.key === 'ArrowRight' || e.keyCode === 39) {
                const focusedItem = document.activeElement;

                if (focusedItem) {
                    const currentIndex = Array.from(menuLinks).indexOf(focusedItem);

                    /* Replace arrow left behavior to jump to previous item */
                    if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                        if (currentIndex > 0) {
                            menuLinks[currentIndex - 1].focus();
                        } else {
                            toggleMenu();
                        }
                    }

                    /* Replace arrow right behavior to jump to next item */
                    if (e.key === 'ArrowRight' || e.keyCode === 39) {
                        if (currentIndex < menuLinks.length - 1) {
                            menuLinks[currentIndex + 1].focus();
                        } else {
                            toggleMenu();
                        }
                    }
                }
            }
        });
    }

    // Add sticky class on scroll.
    window.addEventListener('scroll', toggleSticky);

    // Open Submenu when clicking on items with submenu
    if (menuItems) {
        menuItems.forEach(subItem => {
            subItem.addEventListener('click', openSubmenu);
        });
    }

    // Close Submenu when clicking on back Buttons
    backButtons.forEach(closeButton => {
        closeButton.addEventListener('click', closeSubmenu);
    });

    // Close menus when clicking on links in the menu
    menuLinks.forEach((link, index, linksArray) => {
        link.addEventListener('click', toggleMenu);
    });

    // Opens search box on subsites
    if (subsiteSearchToggler) {
        subsiteSearchToggler.addEventListener('click', function(e) {
            this.style.display = 'none';
            form.style.display = 'flex';
        });
    }

    // Initial setup
    toggleSticky();
    initFeaturedSlider();
});